const HREF =
  'https://fonts.googleapis.com/css2?family=Zen+Old+Mincho:wght@400;700;900&family=Libre+Baskerville:wght@400;700&display=swap';

/** Google Fonts の <link> を一度だけ head に入れる */
export function injectFonts(): void {
  if (document.querySelector('link[data-waggle-fonts]')) return;
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = HREF;
  l.dataset.waggleFonts = '1';
  document.head.appendChild(l);
}
